import React from 'react';
import Common from "./Common";

const Home = () => {
    return(<>
    <Common />
    </>
    );
}
export default Home;